import Dialog from 'components/overlays/Dialog';
import './_styles.scss';

import { useSelector } from 'react-redux';
import { getUserDialog } from 'store/slices/settingsPageSlice';

import type { UserFormData } from './types';
import UserForm from './UserForm';

interface UserDialogProps {
    isLoading: boolean;
    isExecuting: boolean;
    isError: boolean;
    onCancel: () => void;
    onConfirm: (data: UserFormData) => void;
}

const UserDialog = ({ onConfirm, isLoading, onCancel, isExecuting }: UserDialogProps) => {
    const { user, showUserDialog } = useSelector(getUserDialog);
    const showCloseButton = true;

    let activeTitle;

    if (user === undefined) {
        activeTitle = 'Add information about the new user';
    } else {
        activeTitle = 'Edit user information';
    }

    return (
        <Dialog
            key={user?.id ?? 'new-user'}
            showCloseButton={showCloseButton}
            data-testid='create-user-dialog'
            bodyClassName='UserDialog'
            show={showUserDialog}
            title={<p className='CreateUserDialog__title'>{activeTitle}</p>}
            body={
                <div className='UserDialog__bodyContent p-0'>
                    <UserForm
                        user={user}
                        onSubmit={onConfirm}
                        onCancel={onCancel}
                        isLoading={isLoading}
                        isExecuting={isExecuting}
                    />
                </div>
            }
            onClose={onCancel}
            disableEsc={isLoading}
            size='md'
        />
    );
};

export default UserDialog;
